import React from "react";
import { Link } from "@fluentui/react";
import oandoBrand from "./images/brand.jpg";
import shellBrand from "./images/Shell.png";

const _ = require("underscore");
export function OandoLogo() {
  let brandPix = oandoBrand;
  /* if (window.location.hostname === "localhost") {
    brandPix = shellBrand;
  } */
  return (
    <div className="ms-Grid-row">
      <div
        className="ms-Grid"
        dir="ltr"
        style={{
          paddingTop: "20px",
          position: "absolute",
          bottom: "0px",
          background: "white",
        }}
      >
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm1">
            <i className="ms-Icon ms-Icon--Fingerprint ms-fontSize-32 fingerprint" />
          </div>
          <div className="ms-Grid-col ms-sm12 ">
            <img
              src={brandPix}
              alt="brand logo"
              style={{ width: "300px" }}
            ></img>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm12 ms-fontSize-12"
            style={{ color: "black" }}
          >
            Smart Production Analytics and Reporting System ©{" "}
            {new Date().getFullYear()}.
            <br />
            All Rights Reserved.
            <br />
            Powered by{" "}
            <Link href={"mailto:projects@cybersprintitsolutions.com"}>
              CyberSprint Technology Services Limited
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

